'use client';

export { default } from './StyledEngineProvider';


//////////////////
// WEBPACK FOOTER
// ../@mui/styled-engine/StyledEngineProvider/index.js
// module id = 1564
// module chunks = 22